<ng-container *ngFor="let item of items">
    <app-radio-button [checked]="item.isRefined"
                      (changed)="refine.emit(item.value)"
                      (click)="checkIfChecked(item)"
    >
        <span class="refinement-label">
            <span class="refinement-label__text">{{ item.label }}</span>
            <span class="refinement-label__count">{{ item.count }}</span>
        </span>
    </app-radio-button>

    <div class="categories-refinement-list-contents__subcategory-list">
        <app-categories-refinement-list-contents *ngIf="item.data"
                                                 [items]="item.data"
                                                 (refine)="refine.emit($event)"
        ></app-categories-refinement-list-contents>
    </div>
</ng-container>
